import { get, ref, set } from "firebase/database";
import { auth, database } from "../../../Utils/firebase";
import { getAdditionalUserInfo, signInWithCustomToken } from "firebase/auth";
import { storeSessionData } from "../Session/AddSession";
import { GetAllData } from "../..";
import * as actionType from '../../../context/actions'
import AddUserDataInFirebase from "../User/AddUserDataInFirebase";
import SyncReferralMapping from "../User/SyncReferralMapping";
import { logEvent } from '../../../helper/shakebug';

let confirmationResultRef = null;


export const LoginWithPhone = async (phoneNumber, token, uid, state, dispatch, setIsLoading) => {
    try {

        const authId = uid;
        await signInWithCustomToken(auth, token);
        const data = {
            name: "",
            email: "", // <-- fix this
            userPhoto: "",
            user_uid: authId || "",
            contact: phoneNumber || "",
            social_id: phoneNumber || "",
            currency: "IND",
            razorpayId: null,
            platform: "Website",
        }

        const firebaseRef = ref(database, `invoiceGenerator/users/${authId}`);
        const firebaseSnapshot = await get(firebaseRef);
        const firebaseData = firebaseSnapshot.val();

        if (firebaseData === null || firebaseData === undefined) {
            // New User: Sync and generate referral code
            const finalCode = await SyncReferralMapping(authId, data, dispatch);
            data.referral_code = finalCode;

            const userRef = ref(database, `invoiceGenerator/users/${authId}/user`);
            await set(userRef, data);

        } else {
            const userRef = ref(database, `invoiceGenerator/users/${authId}/user`);
            const snapshot = await get(userRef);
            const userdata = snapshot.val();

            if (userdata != null || userdata != undefined) {
                // Existing User: Sync mapping
                const finalCode = await SyncReferralMapping(authId, userdata || data, dispatch);

                data.name = userdata?.name || "";
                data.email = userdata?.email || "";
                data.contact = userdata?.contact || "";
                data.currency = userdata?.currency || "";
                data.razorpayId = userdata?.razorpayId || "";
                data.platform = userdata?.platform || "Website";
                data.referral_code = finalCode || userdata?.referral_code || "";
            }
        }

        dispatch({ type: actionType.USERID, payload: authId });
        dispatch({ type: actionType.SET_USER, payload: data });

        await storeSessionData(authId);

        await GetAllData(state, dispatch);

        localStorage.setItem("AccessUserId", authId);
        localStorage.removeItem("isLocal");
        localStorage.removeItem("LOCAL_BUSINESSES");
        localStorage.removeItem("LOCAL_INVOICES");
        localStorage.removeItem("LOCAL_EXPENSE");
        localStorage.removeItem("LOCAL_SALE_RETURN");
        localStorage.removeItem("LOCAL_EXPENSE");


        setIsLoading(false)

        // // ✅ Redirect after login
        window.location.replace("/dashboard");

    } catch (error) {
        console.log("Phone Login Error:", error.message);
    }
};